module.exports = class ListCtrl
  constructor: (ClientVersionService) ->
    'ngInject'
    @client_versions = ClientVersionService.getList().$object
